import { ColumnsType } from "antd/es/table";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import UserInfo from "./_componnents/UserInfo";

export default function Settings() {
  const { page, limit, handlePagination, handleLimit } = useTable();

  const leaveSettingsTabList = [
    {
      label: "User Info",
      link: `/organization/settings`,
    },
    // {
    //   label: "Change Password",
    //   link: `/organization/settings/change-password`,
    // },
  ];

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "Login Time",
      dataIndex: "loginTime",
    },
    {
      title: "Logout Time",
      dataIndex: "logoutTime",
    },
    {
      title: "IP Adress",
      dataIndex: "IpAdress",
    },
  ];

  return (
    <SidebarLayout
      title="Settings"
      contentClass="!min-h-[calc(100vh-136px)]"
      tabList={leaveSettingsTabList}
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-4 pb-4">
        {/* Left Section */}
        <div className="space-y-4">
          <UserInfo />
        </div>
        {/* Right Section */}
        {/* <div className="lg:col-span-2 space-y-4">
          <CustomTable
            tableTitle="Access Log"
            loading={false}
            limit={limit}
            page={page}
            columns={columns}
            total={11}
            dataSource={addKeyInArray(data)}
            handleLimit={handleLimit}
            handlePagination={handlePagination}
            filterSection={
              <>
                <Button
                  icon={<GrayRefreshIcon />}
                  size="small"
                  className="middle-button normal-button !w-7 !h-7"
                />
              </>
            }
          />
        </div> */}
      </div>
    </SidebarLayout>
  );
}

interface LeaveDataType {
  key: string;
  loginTime: string;
  logoutTime: string;
  IpAdress: string;
}

// const data: LeaveDataType[] = [
//   {
//     key: "1",
//     loginTime: "2024-02-05 14:01:35",
//     logoutTime: "2024-02-05 14:02:48",
//     IpAdress: "10.10.100.40	",
//   },
//   {
//     key: "2",
//     loginTime: "2024-02-05 14:01:35",
//     logoutTime: "2024-02-05 14:02:48",
//     IpAdress: "10.10.100.40	",
//   },
//   {
//     key: "3",
//     loginTime: "2024-02-05 14:01:35",
//     logoutTime: "2024-02-05 14:02:48",
//     IpAdress: "10.10.100.40	",
//   },

//   {
//     key: "4",
//     loginTime: "2024-02-05 14:01:35",
//     logoutTime: "2024-02-05 14:02:48",
//     IpAdress: "10.10.100.40	",
//   },
// ];
